import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import { Button as PrimeButton } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Calendar } from "primereact/calendar";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { SERVICE_LOCATION, GET_MEASURE_REVISITS, DOWNLOAD_SUBMITTED_WORKSHEETS } from "./../constants/endpoints";
import { WORKCARDS_DOWNLOADED } from "./../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";

const MeasureRevisits = (props) => {
    const toast = useRef(null);

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";

    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [minToDate, setMinToDate] = useState(null);
    const [disableGoButton, setDisableGoButton] = useState(null);
    const [measureRevisits, setMeasureRevisits] = useState(null);
    const [selectedWorksheets, setSelectedWorksheets] = useState(null);
    const [disableDownloadButton, setDisableDownloadButton] = useState(true);

    useEffect(() => {
        const currentDate = new Date();
        const previousDate = new Date(currentDate);
        previousDate.setDate(currentDate.getDate() - 2);
        setFromDate(previousDate);
        setToDate(currentDate);
        getMeasureRevisits(previousDate, currentDate);
    }, []);

    const getMeasureRevisits = (selectedFromDate, selectedToDate) => {
        setLoading(true);
        setDisableDownloadButton(true);
        const formatedFromDate = getFormattedDate(selectedFromDate);
        const formatedToDate = getFormattedDate(selectedToDate)
        const requestData = {
            startDate: formatedFromDate,
            endDate: formatedToDate,
            depot: userDepot,
            fitterId: 0,
            isGetByFitterId: false
        }
        const endPoint = SERVICE_LOCATION + GET_MEASURE_REVISITS;
        axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                setMeasureRevisits(null);
                if (response.data.isSuccess) {
                    const result = response.data.data.measureRevisits;
                    setMeasureRevisits(result);
                }
                else if (!response.data.isSuccess) {
                    setMeasureRevisits(null);
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const handlePDFDownload = () => {
        setLoading(true);
        var selectedSubmissions = [];
        selectedWorksheets.forEach(worksheet => {
            const submission = {
                submissionId: worksheet.submissionId
            }
            selectedSubmissions.push(submission);
        })
        const endPoint = SERVICE_LOCATION + DOWNLOAD_SUBMITTED_WORKSHEETS;
        axios.post(endPoint, selectedSubmissions, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    if (response.data.data.downloadedWorkCards.length > 0) {
                        (response.data.data.downloadedWorkCards).forEach(workcard => {
                            const base64 = workcard.chunks.join("");
                            const base64String = "data:application/pdf;base64," + base64;
                            const linkSource = base64String;
                            const downloadLink = document.createElement("a");
                            const fileName = workcard.fileName;
                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                        });
                    }
                    toast.current.show({ severity: "success", summary: "success", detail: WORKCARDS_DOWNLOADED, life: 5000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
            })
    }

    const handleWorksheetSelection = (e) => {
        setSelectedWorksheets(e.value);
        e.value.length > 0 ? setDisableDownloadButton(false) : setDisableDownloadButton(true);
    }

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const handleGo = () => {
        getMeasureRevisits(fromDate, toDate);
    }

    const handleFromDate = (e) => {
        const dateSelected = e.value;
        setFromDate(dateSelected);
        setMinToDate(dateSelected);
        setToDate(null);
        setDisableGoButton(true);
    }

    const handleToDate = (e) => {
        const dateSelected = e.value;
        setToDate(dateSelected);
        setDisableGoButton(false);
    }

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setGlobalFilterValue("");
    }


    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        siteName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        siteAddress: { value: null, matchMode: FilterMatchMode.CONTAINS },
        siteTelNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        plotNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
        plotDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
        worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        measureStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
        measureCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        measureDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
        measureType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        planDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
        crew: { value: null, matchMode: FilterMatchMode.CONTAINS },
        depot: { value: null, matchMode: FilterMatchMode.CONTAINS },
        resourceCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submissionStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
        isSubmitted: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="from-date">From</label>
                    <Calendar id="from-date" name="from-date" value={fromDate} onChange={handleFromDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="to-date">To</label>
                    <Calendar id="to-date" name="to-date" value={toDate} onChange={handleToDate} minDate={minToDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 padt-23">
                    <Button id="go" label="Go" disabled={disableGoButton} onClick={handleGo}>GO</Button>
                </div>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 padt-15">
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search functionality Ends here

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            <div className="worksheets-section">
                <div className="row padb-10">
                    <div className="col-3">
                        <h4>Measure Revisits</h4>
                    </div>
                    <div className="col-9 buttons-right">
                        <div className="padr-10">
                            <Button className="btn-secondary" onClick={handlePDFDownload} disabled={disableDownloadButton}>Download Worksheet(s) PDF</Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={measureRevisits} selection={selectedWorksheets} selectionMode="checkbox"
                            onSelectionChange={handleWorksheetSelection} dataKey="id" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                            filters={filters} header={header} filterDisplay="row"
                            globalFilterFields={["id", "clientAccount", "clientName", "clientAddress", "clientTerms", "paymentFormRequired",
                                "ContractNumber", "specialNotes", "siteRefNumber", "siteName", "siteAddress", "siteTelNo", "plotID", "plotNumber", "plotDescription",
                                "worksheetNo", "worksheetCode", "measureId", "measureStatus", "measureQuantity", "measureCode", "measureDescription", "cavityDepth",
                                "measureType", "planDate", "m2", "depot", "depotCode", "resourceCode", "crew", "submissionId",
                                "submissionType", "submissionStatus", "submittedBy", "submittedDate", "isSubmitted"]}
                            scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No measure revisits avaialble.">
                            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                            <Column field="id" header="Id" className="table-header" hidden></Column>
                            <Column field="submissionStatus" header="Submission Status" className="table-header" hidden></Column>
                            <Column field="clientAccount" header="Client Account" className="table-header" hidden></Column>
                            <Column field="clientName" key="clientName" header="Client Name" filter filterPlaceholder="Search by client name" className="table-header" ></Column>
                            <Column field="clientAddress" header="Client Address" className="table-header" hidden></Column>
                            <Column field="clientTerms" header="Client Terms" className="table-header" hidden></Column>
                            <Column field="paymentFormRequired" header="PaymentForm Required" className="table-header" hidden></Column>
                            <Column field="contractNumber" header="Contract Number" className="table-header" hidden></Column>
                            <Column field="specialNotes" header="Special Notes" className="table-header" hidden></Column>
                            <Column field="siteRefNumber" header="Site Ref Number" className="table-header" hidden></Column>
                            <Column field="siteName" header="Site Name" filter filterPlaceholder="Search by site name" className="table-header"></Column>
                            <Column field="siteAddress" header="Site Address" filter filterPlaceholder="Search by site address" className="table-header"></Column>
                            <Column field="siteTelNo" header="Site Telephone No" filter filterPlaceholder="Search by telephone" className="table-header"></Column>
                            <Column field="plotID" header="Plot ID" className="table-header" hidden></Column>
                            <Column field="plotNumber" header="Plot Number" filter filterPlaceholder="Search by plot number" className="table-header"></Column>
                            <Column field="plotDescription" header="Plot Description" filter filterPlaceholder="Search by plot description" className="table-header"></Column>
                            <Column field="worksheetNo" header="Worksheet No" filter filterPlaceholder="Search by worksheet no" className="table-header"></Column>
                            <Column field="worksheetCode" header="Worksheet Code" filter filterPlaceholder="Search by worksheet code" className="table-header" hidden></Column>
                            <Column field="measureId" header="Measure Id" filter filterPlaceholder="Search by measure id" className="table-header" hidden></Column>
                            <Column field="measureStatus" header="Measure Status" filter filterPlaceholder="Search by measure status" className="table-header"></Column>
                            <Column field="measureQuantity" header="Measure Quantity" className="table-header" hidden></Column>
                            <Column field="measureCode" header="Measure Code" filter filterPlaceholder="Search by measure code" className="table-header"></Column>
                            <Column field="measureDescription" header="Measure Description" filter filterPlaceholder="Search by measure description" className="table-header"></Column>
                            <Column field="cavityDepth" header="Cavity Depth" className="table-header" hidden></Column>
                            <Column field="measureType" header="Measure Type" filter filterPlaceholder="Search by measure type" className="table-header"></Column>
                            <Column field="planDate" header="Rescheduled Date" filter filterPlaceholder="Search by plan date" className="table-header"></Column>
                            <Column field="m2" header="M2" className="table-header" hidden></Column>
                            <Column field="depot" header="Depot" filter filterPlaceholder="Search by depot" className="table-header"></Column>
                            <Column field="depotCode" header="Depot Code" className="table-header" hidden></Column>
                            <Column field="resourceCode" header="Resource Code" className="table-header" hidden></Column>
                            <Column field="crew" header="Crew" filter filterPlaceholder="Search by crew" className="table-header"></Column>
                            <Column field="submissionId" header="Submission Id" className="table-header" hidden></Column>
                            <Column field="submissionType" header="Submission Type" className="table-header" hidden></Column>
                            <Column field="submittedBy" header="Submitted By" className="table-header" hidden></Column>
                            <Column field="submittedDate" header="Submitted Date" className="table-header" hidden></Column>
                            <Column field="isSubmitted" header="Is Submitted" filter filterPlaceholder="Search by submission" className="table-header" hidden></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MeasureRevisits;